<template>
  <div>
    <b-card>
      <b-card-header>
        <b-card-title>Super Admin Profile</b-card-title>
      </b-card-header>
      <b-card-body>
        <b-form @submit.prevent="updateProfile">
          <!-- Name -->
          <b-form-group label="Name" label-for="name">
            <b-form-input
              id="name"
              v-model="profile.name"
              type="text"
              :state="nameState"
              required
            ></b-form-input>
            <b-form-invalid-feedback>
              Name must be at least 3 characters long
            </b-form-invalid-feedback>
          </b-form-group>

          <!-- Email (disabled) -->
          <b-form-group label="Email" label-for="email">
            <b-form-input
              id="email"
              v-model="profile.email"
              type="email"
              disabled
            ></b-form-input>
            <small class="text-muted">Email cannot be changed</small>
          </b-form-group>

          <!-- Password -->
          <b-form-group label="Password" label-for="password">
            <b-form-input
              id="password"
              v-model="profile.password"
              type="password"
              :state="passwordState"
              placeholder="Leave blank if not changing"
            ></b-form-input>
            <b-form-invalid-feedback>
              Password must be at least 6 characters
            </b-form-invalid-feedback>
          </b-form-group>

          <!-- Confirm Password -->
          <b-form-group label="Confirm Password" label-for="password_confirmation">
            <b-form-input
              id="password_confirmation"
              v-model="profile.password_confirmation"
              type="password"
              :state="confirmPasswordState"
              placeholder="Leave blank if not changing"
            ></b-form-input>
            <b-form-invalid-feedback>
              Password confirmation does not match
            </b-form-invalid-feedback>
          </b-form-group>

          <!-- Submit -->
          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="primary" :disabled="loading || !formValid">
              {{ loading ? "Updating..." : "Update Profile" }}
            </b-button>
          </div>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormInvalidFeedback,
} from "bootstrap-vue";

export default {
  name: "ProfileView",
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormInvalidFeedback,
  },
  data() {
    return {
      profile: {
        id: null,
        name: "",
        email: "",
        status: "",
        password: null,
        password_confirmation: null,
      },
      loading: false,
      error: null,
    };
  },
  created() {
    this.fetchProfile();
  },
  computed: {
    // ✅ Validation states
    nameState() {
      return this.profile.name.length >= 3 ? true : null;
    },
    passwordState() {
      if (!this.profile.password) return null; // optional
      return this.profile.password.length >= 6;
    },
    confirmPasswordState() {
      if (!this.profile.password && !this.profile.password_confirmation) return null;
      return this.profile.password === this.profile.password_confirmation;
    },
    formValid() {
      return (
        this.profile.name.length >= 3 &&
        (this.passwordState !== false && this.confirmPasswordState !== false)
      );
    },
  },
  methods: {
    async fetchProfile() {
      try {
        this.loading = true;
        const res = await this.$api.get("/api/super-admin/profile");
        this.profile = {
          ...res.data,
          password: "",
          password_confirmation: "",
        };
      } catch (err) {
        console.error("Failed to fetch profile", err);
        this.error = "Failed to fetch profile";
      } finally {
        this.loading = false;
      }
    },
    async updateProfile() {
      if (!this.formValid) return;

      try {
        this.loading = true;
        await this.$api.put("/api/super-admin/profile", this.profile);
        this.$bvToast.toast("Profile updated successfully", {
          title: "Success",
          variant: "success",
          solid: true,
        });
        this.fetchProfile();
      } catch (err) {
        console.error("Failed to update profile", err);
        this.$bvToast.toast("Failed to update profile", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
